<template>
  <a :href="link" :target="target" :style="styleObject()">{{ text }}</a>
</template>

<script>
export default {
  name: "HyperLink",
  props: {
    link: String,
    text: String,
    target: String,
  },
  methods: {
    styleObject() {
      return {
        color: this.$vuetify.theme.themes.light.primary,
        "text-transform": "uppercase",
      };
    },
  },
};
</script>
